import * as Yup from "yup";

export function inititalValues(user) {
  return {
    email: user? user.email : "",
    resetPasswordToken: user? user.resetPasswordToken : "",
    resetPasswordExpires: user? user.resetPasswordExpires : ""
  };
}

export function validationSchema(t) {
  return Yup.object({
    email: Yup.string()
      .email(t("invalid_email"))
      .required(t("required_field")),
    password: Yup.string()
      .required(t("required_field")),
    repeatPassword: Yup.string()
      .required(t("required_field"))
  });
}
